/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Route } from 'react-router';
import { NotFoundPage, RequireAuthExternal } from 'sarsaparilla';
import { MobileSessionHandoff } from 'shared-ui/mobile-session';

import routesArray from './routesArray';

import {
    FacilityPageContainer,
    MobileCreateReservationContainer,
    TourDetailsPageContainer,
    OrderDetailsPageContainer,
    CartlessConfirmationContainer,
} from '../src/containers';

const Components = {
    FacilityPageContainer,
    MobileCreateReservationContainer,
    TourDetailsPageContainer,
    OrderDetailsPageContainer,
    CartlessConfirmationContainer,
};

export default function makeSwitchRoutes() {
    const routeComponents = routesArray.map((route) => {
        const Component = Components[route.componentName];

        if (route.requireAuth) {
            return (
                <Route
                    key={route.path}
                    path={route.path}
                    element={
                        <RequireAuthExternal>
                            <Component />
                        </RequireAuthExternal>
                    }
                />
            );
        }
        return <Route key={route.path} path={route.path} element={<Component />} />;
    });

    routeComponents.push(
        <Route path="timed-entry/mobile/session" element={<MobileSessionHandoff />} />
    );
    routeComponents.push(<Route path="*" key="notFound" element={<NotFoundPage />} />);

    return routeComponents;
}
